import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/auth.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-zone7',
    templateUrl: './zone7.component.html',
    styleUrls: ['./zone7.component.scss'],
    standalone: false
})
export class Zone7Component implements OnInit, OnDestroy {
    activeContinent: number;
    zones = [
        {
            id: '2-3-1',
            number: 25,
            class: 'germany',
            locked: false,
            active: false,
            hover: false
        },
        {
            id: '2-3-2',
            number: 26,
            class: 'uk',
            locked: false,
            active: false,
            hover: false
        },
        {
            id: '2-3-3',
            number: 27,
            class: 'france',
            locked: false,
            active: false,
            hover: false
        },
        {
            id: '2-3-4',
            number: 28,
            class: 'spain',
            locked: false,
            active: false,
            hover: false
        }
    ];

    public activeZone = 1;
    openZones: number;
    tick2Quiz: boolean = true;
    quizLevel: any;
    plane: any = {
        position: 1
    };
    loading = true;
    user: any;
    adminUserData;

    constructor(private router: Router, private auth: AuthService) { }

    ngOnInit() {
        this.tick2Quiz = true;
        this.userSubscription = this.auth.onUserUpdate.subscribe(userData => {
            if (userData != null && userData) this.loadChildData(userData);
        }, error => {
            console.log('error', error);
        });
    }
    userSubscription: Subscription;

    ngOnDestroy() {
        this.userSubscription.unsubscribe();
    }

    loadChildData(userData) {
        this.zones = [
            {
                id: '2-3-1',
                number: 25,
                class: 'germany',
                locked: false,
                active: false,
                hover: false
            },
            {
                id: '2-3-2',
                number: 26,
                class: 'uk',
                locked: false,
                active: false,
                hover: false
            },
            {
                id: '2-3-3',
                number: 27,
                class: 'france',
                locked: false,
                active: false,
                hover: false
            },
            {
                id: '2-3-4',
                number: 28,
                class: 'spain',
                locked: false,
                active: false,
                hover: false
            }
        ];

        this.user = userData;

        if (this.user.activities["3-1-1"]) {
            this.tick2Quiz = false;
        }

        // this.openZones = userData.zone1Lvl;
        this.adminUserData = JSON.parse(localStorage.getItem('quranera_admin_userData'));
        if (!userData) {
            if (this.adminUserData) {
                userData = this.adminUserData;
                userData.activeLevel = '9-9-9';
            }
        }
        this.plane.position = this.openZones;
        this.activeZone = this.adminUserData ? 99 : parseInt(userData.activeLevel.split('-')[1], 10);
        this.activeContinent = parseInt(userData.activeLevel.split('-')[0], 10);
        if (this.activeZone > 3) {
            this.openZones = 5;
        } else {
            this.openZones = parseInt(userData.activeLevel.split('-')[2], 10);
        }
        if (userData.quizLevel) {
            this.quizLevel = userData.quizLevel;
        }

        if (this.adminUserData) {
            this.quizLevel = 100;
        }

        if (!this.adminUserData) {
            this.remapZones();
        } else {
            this.zones.map((zone, i) => {
                if (i + 1 <= this.openZones) {
                    this.zones[i].locked = false;
                }
            });
        }
    }

    goQuiz() {
        if (this.quizLevel >= 7) {
            this.router.navigate(['/game/quiz-activity/2-3']);
        }
    }

    remapZones() {
        this.zones.map(zone => {
            if (!this.user.activities[zone.id]) {
                zone.locked = true;
            }
            if (this.user.activeLevel === zone.id && this.user.activities[zone.id]) {
                zone.active = true;
            }
        });
    }

    mouseEnter(zone) {
        const audio = document.getElementById('continentHover') as HTMLAudioElement;
        audio.pause();
        audio.currentTime = 0;
        if (audio) audio.play();
        zone.hover = true;
    }

    mouseLeave(zone) {
        zone.hover = false;
    }

    selectZone(zone) {
        if (!zone.locked) {
            const audio = document.getElementById('continentClick') as HTMLAudioElement;
            if (audio) audio.play();
            setTimeout(() => {
                this.router.navigate([`/game/activity-list/${zone.id}`]);
            }, 1000);
        }
    }

    playBgAudio() {
        let audio = <HTMLAudioElement>document.getElementById('bgAudio');
        if (audio) audio.play();
    }

    playIntroductionAudio() {
        let audio = <HTMLAudioElement>document.getElementById('introductionAudio');
        if (audio) audio.play();
    }

    instructionLoaded() {
        if (this.loading) {
            this.loading = false;
            let audio = <HTMLAudioElement>document.getElementById('introductionAudio');
            if (audio) audio.play();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.loading) {
                this.instructionLoaded();
            }
        }, 2000);
    }

    haveAccess(activityLevel) {
        if (this.adminUserData) return true;

        if (this.user == undefined) return false;
        if (!this.user['activities'][activityLevel + '-1']
            && !this.user['activities'][activityLevel + '-2']
            && !this.user['activities'][activityLevel + '-3']
            && !this.user['activities'][activityLevel + '-4']
        ) return false;

        for (var a = 1; a <= 4; a++) {
            for (var i = 1; i <= 15; i++) {
                if (this.user["activities"][activityLevel + '-' + a.toString()]) {
                    if (this.user["activities"][activityLevel + '-' + a.toString()][i.toString()]) return true;
                }
            }
        }

        return false;
    }
}
